
// header height CSS variable
(function () {
  function setHeaderHeight() {
    const header = document.querySelector('.section-header');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  document.addEventListener('DOMContentLoaded', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
})();

// tabs start
document.addEventListener("DOMContentLoaded", () => {
  const overviewSections = document.querySelectorAll(".tabs-container");

  overviewSections.forEach(section => {
    const tabButtons = section.querySelectorAll(".tab-button");
    const contents = section.querySelectorAll(".tab-content");

    function updateSwiperInContent(content) {
      if (!content) return;

      const swipers = content.querySelectorAll(".swiper[data-swiper]");
      swipers.forEach((slider) => {
        if (slider.swiper) {
          slider.swiper.update();
          slider.swiper.slideTo(0, 0);
        }
      });
    }

    tabButtons.forEach(button => {
      button.addEventListener("click", () => {
        const target = button.getAttribute("data-target");

        tabButtons.forEach(btn => btn.classList.remove("active"));
        contents.forEach(content => content.classList.remove("active"));

        button.classList.add("active");

        const targetContent = section.querySelector(`#${target}`);
        if (targetContent) {
          targetContent.classList.add("active");

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              updateSwiperInContent(targetContent);
            });
          });
        }
      });
    });
  });
});


// Accordion script start 
function initAccordion(scope = document) {
  const triggers = scope.querySelectorAll('[data-toggle="collapse"]');

  if (!window.__accordionActiveByParent) {
    window.__accordionActiveByParent = new Map();
  }

  const activeByParent = window.__accordionActiveByParent;

  triggers.forEach(trigger => {
    if (trigger.dataset.accordionBound === 'true') return;

    const targetSel = trigger.dataset.target;
    if (!targetSel) return;

    const content = scope.querySelector(targetSel) || document.querySelector(targetSel);
    if (!content) return;

    trigger.collapseTarget = content;
    trigger.dataset.accordionBound = 'true';

    const parentSel = content.dataset.parent || null;

    if (content.classList.contains('is-active')) {
      if (parentSel) activeByParent.set(parentSel, trigger);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      toggleAccordion(trigger, activeByParent);
    });

    content.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'height' && content.classList.contains('is-active')) {
        content.style.height = 'auto';
        // Swiper initialises while the accordion is collapsed (height:0), so its
        // internal swiperSize is 0 and mouse-drag silently fails. Update here
        // once the height animation has settled to real dimensions.
        content.querySelectorAll('.swiper[data-swiper]').forEach(function (swiperEl) {
          if (swiperEl.swiper) swiperEl.swiper.update();
        });
      }
    });
  });
}

function toggleAccordion(trigger, activeByParent) {
  const content = trigger.collapseTarget;
  if (!content) return;

  const parentSel = content.dataset.parent || null;

  if (content.classList.contains('is-active')) {
    closeAccordion(trigger);
    if (parentSel && activeByParent.get(parentSel) === trigger) {
      activeByParent.delete(parentSel);
    }
    return;
  }

  if (parentSel) {
    const activeToggle = activeByParent.get(parentSel);
    if (activeToggle && activeToggle !== trigger) {
      closeAccordion(activeToggle);
    }
    activeByParent.set(parentSel, trigger);
  }

  openAccordion(trigger);
}

function closeAccordion(trigger) {
  const content = trigger.collapseTarget;
  if (!content) return;

  content.style.height = content.scrollHeight + 'px';

  requestAnimationFrame(() => {
    content.style.height = '0px';
    content.classList.remove('is-active');
  });

  trigger.classList.remove('is-active');
}

function openAccordion(trigger) {
  const content = trigger.collapseTarget;
  if (!content) return;

  content.style.height = '0px';
  content.classList.add('is-active');
  trigger.classList.add('is-active');

  requestAnimationFrame(() => {
    content.style.height = content.scrollHeight + 'px';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initAccordion();
});

// ========================================
// SWIPER SLDIER START
// ========================================
// data-swiper call
// data-desktop = string
// data-laptop = string
// data-tablet = string
// data-mobile = string
// data-slider-from = string  650 / 992
// data-space= = string
// data-speed = string
// data-loop= = boolean
// data-autoplay = boolean
// data-delay = string
// data-navigation= = boolean
// data-pagination = boolean

function initResponsiveSwiper(slider) {
  if (!slider) return;

  const sliderFrom = parseInt(slider.dataset.sliderFrom) || null;
  const autoplay = slider.dataset.autoplay === "true";
  const delay = parseInt(slider.dataset.delay) || 0;
  const loop = slider.dataset.loop === "true";
  const speed = parseInt(slider.dataset.speed) || 400;
  const space = parseInt(slider.dataset.space) || 20;
  const desktop = parseFloat(slider.dataset.desktop) || 4;
  const laptop = parseFloat(slider.dataset.laptop) || 3;
  const tablet = parseFloat(slider.dataset.tablet) || 2;
  const mobile = parseFloat(slider.dataset.mobile) || 1;
  const navigation = slider.dataset.navigation === "true";
  const pagination = slider.dataset.pagination === "true";

  // Look inside the swiper first; fall back to a sibling .custom-arrow in the parent
  // (used when the arrow markup is placed outside the swiper element to avoid CSS mask clipping)
  const parentArrow = slider.parentElement && slider.parentElement.querySelector(':scope > .custom-arrow');
  const nextBtn = slider.querySelector(".swiper-button-next") ||
                  (parentArrow ? parentArrow.querySelector(".swiper-button-next") : null);
  const prevBtn = slider.querySelector(".swiper-button-prev") ||
                  (parentArrow ? parentArrow.querySelector(".swiper-button-prev") : null);
  const paginationEl = slider.querySelector(".swiper-pagination");
  const arrowWrapper = slider.querySelector(".custom-arrow");

  const shouldEnableSlider = !sliderFrom || window.innerWidth < sliderFrom;

  if (slider.swiper) {
    slider.swiper.destroy(true, true);
  }

  if (shouldEnableSlider) {
    const totalSlides = slider.querySelectorAll(".swiper-slide").length;
    const currentSlidesPerView =
      window.innerWidth >= 1200 ? desktop :
      window.innerWidth >= 992 ? laptop :
      window.innerWidth >= 650 ? tablet :
      mobile;

    const enableLoop = loop && totalSlides > currentSlidesPerView;

    new Swiper(slider, {
      loop: enableLoop,
      speed: speed,
      spaceBetween: space,
      slidesPerView: mobile,
      grabCursor: true,
      simulateTouch: true,
      breakpoints: {
        650: { slidesPerView: tablet },
        992: { slidesPerView: laptop },
        1200: { slidesPerView: desktop }
      },
      autoplay: autoplay
        ? {
            delay: delay,
            disableOnInteraction: false
          }
        : false,
      navigation: navigation && nextBtn && prevBtn
        ? {
            nextEl: nextBtn,
            prevEl: prevBtn
          }
        : false,
      pagination: pagination && paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : false,
      observer: true,
      observeParents: true,
      watchOverflow: true
    });

    if (navigation) {
      if (arrowWrapper) arrowWrapper.style.display = "";
      if (nextBtn) {
        nextBtn.style.display = "";
        nextBtn.style.pointerEvents = "";
        nextBtn.style.opacity = "";
        nextBtn.removeAttribute("disabled");
      }
      if (prevBtn) {
        prevBtn.style.display = "";
        prevBtn.style.pointerEvents = "";
        prevBtn.style.opacity = "";
        prevBtn.removeAttribute("disabled");
      }
    }

    if (paginationEl) {
      paginationEl.style.display = "";
    }
  } else {
    if (navigation) {
      if (arrowWrapper) arrowWrapper.style.display = "none";

      if (nextBtn) {
        nextBtn.setAttribute("disabled", "disabled");
        nextBtn.style.pointerEvents = "none";
        nextBtn.style.opacity = "0.4";
        nextBtn.style.display = "none";
      }

      if (prevBtn) {
        prevBtn.setAttribute("disabled", "disabled");
        prevBtn.style.pointerEvents = "none";
        prevBtn.style.opacity = "0.4";
        prevBtn.style.display = "none";
      }
    }

    if (paginationEl) {
      paginationEl.style.display = "none";
    }
  }
}

function handleResponsiveSwipers(container = document) {
  container.querySelectorAll(".swiper[data-swiper]").forEach(function (slider) {
    initResponsiveSwiper(slider);
  });
}

// Initial page load
document.addEventListener("DOMContentLoaded", function () {
  handleResponsiveSwipers();

  // Watch async-loaded sections like product recommendations
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (node.matches(".swiper[data-swiper]")) {
          initResponsiveSwiper(node);
        } else if (node.querySelector && node.querySelector(".swiper[data-swiper]")) {
          handleResponsiveSwipers(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Resize debounce
let swiperResizeTimer;
window.addEventListener("resize", function () {
  clearTimeout(swiperResizeTimer);
  swiperResizeTimer = setTimeout(function () {
    handleResponsiveSwipers();
  }, 150);
});

// Shopify Theme Editor support
document.addEventListener("shopify:section:load", function (event) {
  handleResponsiveSwipers(event.target);
});

document.addEventListener("shopify:section:reorder", function (event) {
  handleResponsiveSwipers(event.target);
});

document.addEventListener("shopify:block:select", function (event) {
  const section = event.target.closest(".shopify-section");
  if (section) {
    handleResponsiveSwipers(section);
  }
});


// ========================================
// ORDER SAMPLE - Add to Cart Guard
// ========================================
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.osw-add-btn');
  if (!btn) return;
  // Samples inside the quick-view modal are handled by global-quick-view.liquid.
  if (btn.closest('#QuickViewContent')) return;
  e.preventDefault();

  if (btn.dataset.available === 'false') return;

  var variantId = parseInt(btn.dataset.variantId);
  var productId = parseInt(btn.dataset.productId);
  var wrapper = btn.closest('.order-sample-wrapper');

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var alreadyInCart = cart.items.some(function (item) {
        return item.product_id === productId;
      });

      // Count samples already in the cart (line item property _sample or type SAMPLE).
      var sampleQty = cart.items.reduce(function (n, item) {
        var isSample = (item.properties && item.properties._sample) ||
          (item.product_type && String(item.product_type).toUpperCase().indexOf('SAMPLE') !== -1);
        return isSample ? n + item.quantity : n;
      }, 0);

      var blockMessage = '';
      if (alreadyInCart) {
        blockMessage = 'Item in basket already exists';
      } else if (sampleQty >= 5) {
        blockMessage = 'Max 5 samples per order';
      }

      if (blockMessage) {
        var errorEl = wrapper && wrapper.querySelector('.osw-error');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'osw-error';
          errorEl.style.cssText = 'color:#af0000;margin:8px 0 0;font-size:14px;';
          if (wrapper) wrapper.appendChild(errorEl);
        }
        errorEl.textContent = blockMessage;
        errorEl.style.display = 'block';
        setTimeout(function () { errorEl.style.display = 'none'; }, 3000);
        return;
      }

      var originalHTML = btn.innerHTML;
      btn.innerHTML = 'Adding&hellip;';
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.65';

      var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('properties[_sample]', '1');
      formData.append('sections_url', window.location.pathname);
      if (cartEl) {
        cartEl.getSectionsToRender().forEach(function (s) { formData.append('sections[]', s.id); });
        cartEl.setActiveElement(document.activeElement);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          btn.innerHTML = originalHTML;
          btn.style.pointerEvents = '';
          btn.style.opacity = '';
          return;
        }
        btn.innerHTML = 'Added!';
        if (cartEl) {
          cartEl.classList.remove('is-empty');
          cartEl.renderContents(response);
        }
        if (typeof window.syncSampleBtns === 'function') window.syncSampleBtns();
        setTimeout(function () {
          btn.innerHTML = originalHTML;
          btn.style.pointerEvents = '';
          btn.style.opacity = '';
        }, 2500);
      })
      .catch(function () {
        btn.innerHTML = originalHTML;
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      });
    });
});


// Search modal blur overlay
// backdrop-filter can't apply on .modal-overlay::after because .search-modal has a
// CSS transform animation that creates a stacking context, trapping the blur inside it.
// Fix: inject a body-level overlay so it sits outside that stacking context.
(function () {
  function initSearchOverlay() {
    const headerSearch = document.querySelector('.header__search');
    if (!headerSearch) return;

    const details = headerSearch.querySelector('details');
    if (!details) return;

    const overlay = document.createElement('div');
    overlay.id = 'search-blur-overlay';
    overlay.style.cssText = [
      'position:fixed',
      'inset:0',
      'background:color-mix(in srgb, var(--color-spot-1) 80%, transparent)',
      '-webkit-backdrop-filter:blur(10px)',
      'backdrop-filter:blur(10px)',
      'z-index:9909',
      'pointer-events:none',
      'opacity:0',
      'transition:opacity 0.3s ease',
      'display:none'
    ].join(';');
    document.body.appendChild(overlay);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== 'open') return;
        if (details.hasAttribute('open')) {
          overlay.style.display = 'block';
          requestAnimationFrame(function () {
            overlay.style.opacity = '1';
          });
        } else {
          overlay.style.opacity = '0';
          overlay.addEventListener('transitionend', function () {
            overlay.style.display = 'none';
          }, { once: true });
        }
      });
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchOverlay);
  } else {
    initSearchOverlay();
  }
})();


// video popup script
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("reviewVideoPopup");
  const frame = document.getElementById("reviewVideoFrame");
  if (!popup || !frame) return;

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".video-trigger");
    if (!btn) return;

    const videoType = btn.dataset.videoType || "";
    const uploadSrc = btn.dataset.videoSrc || "";
    const url = btn.dataset.videoUrl || "";
    const videoLayout = btn.dataset.videoLayout || "portrait";
    let html = "";

    popup.classList.remove("is-landscape", "is-portrait");
    popup.classList.add(videoLayout === "portrait" ? "is-portrait" : "is-landscape");

    if (videoType === "upload" && uploadSrc) {
      html = `
        <video class="popup-video" src="${uploadSrc}" autoplay muted playsinline controls></video>
      `;
    } else if (videoType === "url" && url) {
      if (url.includes("youtube") || url.includes("youtu.be")) {
        let id = "";

        if (url.includes("v=")) {
          id = url.split("v=")[1].split("&")[0];
        } else {
          id = url.split("/").pop().split("?")[0];
        }

        html = `
          <iframe
            src="https://www.youtube.com/embed/${id}?autoplay=1&mute=1&playsinline=1&rel=0"
            allow="autoplay; encrypted-media"
            allowfullscreen>
          </iframe>
        `;
      } else if (url.includes("vimeo")) {
        const id = url.split("/").pop().split("?")[0];
        html = `
          <iframe
            src="https://player.vimeo.com/video/${id}?autoplay=1&muted=1"
            allow="autoplay; fullscreen"
            allowfullscreen>
          </iframe>
        `;
      } else {
        html = `
          <video class="popup-video" autoplay muted playsinline controls>
            <source src="${url}" type="video/mp4">
          </video>
        `;
      }
    } else {
      return;
    }

    frame.innerHTML = html;
    popup.classList.add("active");
    document.body.classList.add("overflow-hidden");

    const video = frame.querySelector(".popup-video");
    if (video) {
      video.muted = true;
      video.playsInline = true;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function (error) {
          console.log("Autoplay blocked:", error);
        });
      }
    }
  });

  function closeVideo() {
    const video = frame.querySelector(".popup-video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    popup.classList.remove("active", "is-landscape", "is-portrait");
    frame.innerHTML = "";
    document.body.classList.remove("overflow-hidden");
  }

  const overlay = popup.querySelector(".review-video-popup__overlay");
  const closeBtn = popup.querySelector(".review-video-popup__close");

  if (overlay) overlay.addEventListener("click", closeVideo);
  if (closeBtn) closeBtn.addEventListener("click", closeVideo);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popup.classList.contains("active")) {
      closeVideo();
    }
  });
})


